

module.exports = __webpack_require__.stylable.create(
    "SessionDetails4121853940",
    {"classes":{"root":"SessionDetails4121853940__root","details":"SessionDetails4121853940__details","locationWrapper":"SessionDetails4121853940__locationWrapper","detailWrapper":"SessionDetails4121853940__detailWrapper","duration":"SessionDetails4121853940__duration","staff":"SessionDetails4121853940__staff","location":"SessionDetails4121853940__location","locationIcon":"SessionDetails4121853940__locationIcon","startTime":"SessionDetails4121853940__startTime","srOnly":"SessionDetails4121853940__srOnly"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "SessionDetails4121853940",
    null
);
